import { type ActionsUnion, createAction } from "@/common/action_helpers"
import { type SignHistoryState } from "@/signomatic/app/sign_history"

export enum ActionTypes {
  RESET_TOOLBOX = "reset toolbox",
  RESET_SIZE_TOOLBOX = "reset size toolbox",
  SET_TOOLBOX = "set toolbox",
  TOGGLE_TOOLBOX = "toggle toolbox",
  SET_TOOLBOX_HEIGHT = "set toolbox heigth",
  SET_STATE_CHANGE_TOOLBOX = "set toolbox to open on state change",
  SET_SUB_TOOLBOX = "set sub-toolbox",
  SET_SUB_TARGET = "set sub-target",
  ADD_SUB_TOOLBOX = "add sub-toolbox",
  SET_SIGN_TYPE = "set sign type",
  SET_META_SIGN_TYPE = "set meta sign type",
  SET_SIGN_STATE = "set sign state",
  OPEN_FILE_IMPORT = "open file import",
  CLOSE_FILE_IMPORT = "close file import",
  SET_ACTIVE_OBJECT = "set active object",
  SET_HISTORY = "set history",
  OPEN_FONT_UPLOAD = "open font upload",
  CLOSE_FONT_UPLOAD = "close font upload",
  REMOVE_EDITING = "remove editing",
}

export const actions = {
  setSignType: (type: string) => createAction(ActionTypes.SET_SIGN_TYPE, type),
  setMetaSignType: (metaProduct: string, signType?: string) =>
    createAction(ActionTypes.SET_META_SIGN_TYPE, { metaProduct, signType }),
  resetToolbox: () => createAction(ActionTypes.RESET_TOOLBOX),
  resetSizeToolbox: () => createAction(ActionTypes.RESET_SIZE_TOOLBOX),
  setToolbox: (type: string | null, index?: number, presetGroup?: string) =>
    createAction(ActionTypes.SET_TOOLBOX, { type, index, presetGroup }),
  toggleToolbox: (type: string) => createAction(ActionTypes.TOGGLE_TOOLBOX, type),
  setToolboxHeight: (height: number) => createAction(ActionTypes.SET_TOOLBOX_HEIGHT, height),
  setStateChangeToolbox: (type: string) => createAction(ActionTypes.SET_STATE_CHANGE_TOOLBOX, { type }),
  setSubToolbox: (type: string | null, target?: string) => createAction(ActionTypes.SET_SUB_TOOLBOX, { type, target }),
  setSubTarget: (target: string) => createAction(ActionTypes.SET_SUB_TARGET, { target }),
  addSubToolbox: (type: string, target?: string | null) => createAction(ActionTypes.ADD_SUB_TOOLBOX, { type, target }),
  setSignState: (signState: SignState, signData: SignData[]) =>
    createAction(ActionTypes.SET_SIGN_STATE, { signState, signData }),
  setActiveObject: (state?: SignObjectState) => createAction(ActionTypes.SET_ACTIVE_OBJECT, state),
  openFileImport: () => createAction(ActionTypes.OPEN_FILE_IMPORT),
  closeFileImport: () => createAction(ActionTypes.CLOSE_FILE_IMPORT),
  setHistory: (state?: SignHistoryState) => createAction(ActionTypes.SET_HISTORY, state),
  openFontUpload: () => createAction(ActionTypes.OPEN_FONT_UPLOAD),
  closeFontUpload: () => createAction(ActionTypes.CLOSE_FONT_UPLOAD),
  removeEditing: () => createAction(ActionTypes.REMOVE_EDITING),
}

export type Actions = ActionsUnion<typeof actions>
